import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData';

import { FORMAT_DEFAULT } from 'dayjs/constant'

function localizedFormat(o, c, d) {
  var proto = c.prototype;
  var oldFormat = proto.format;
  var englishFormats = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    l: 'MM/DD',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };
  d.en.formats = englishFormats;

  proto.format = function (formatStr) {
    var locale = this.$locale();
    var formats = locale.formats || {};
    var str = formatStr || FORMAT_DEFAULT;
    var result = str.replace(/LTS|LT|L|l{1,4}/g, function (match) {
      return formats[match] || englishFormats[match];
    });
    return oldFormat.call(this, result);
  };
}
dayjs.extend(localizedFormat)

const isoCode = document.documentElement.lang || 'en-gb'

function setDayjsLocale(module) {
  const locale = module.default;
  dayjs.extend(localeData)

  switch (locale.name) {
    case 'sv':
      locale.formats['L'] = 'DD/MM/YYYY';
      break;
    case 'fr':
      locale.formats['L'] = 'DD.MM.YYYY';
      break;
  }

  locale.formats['l'] = locale.formats['L'].replace(/[\-/]?YYYY[\-/]?/, '');

  dayjs.locale(locale, null, true);
  dayjs.locale(isoCode);

  return {
    ...locale,
    months: dayjs.months(),
    monthsShort: dayjs.monthsShort(),
    weekdays: dayjs.weekdays(),
    weekdaysShort: dayjs.weekdaysShort(),
    weekdaysMin: dayjs.weekdaysMin(),
  };
}

export default (() => {
  switch (isoCode) {
    case 'de':
      return import('dayjs/locale/de').then(setDayjsLocale)
    case 'en':
      return import('dayjs/locale/en').then(setDayjsLocale)
    case 'en-gb':
      return import('dayjs/locale/en-gb').then(setDayjsLocale)
    case 'nl':
      return import('dayjs/locale/nl').then(setDayjsLocale)
    case 'fr':
      return import('dayjs/locale/fr').then(setDayjsLocale)
    case 'es':
      return import('dayjs/locale/es').then(setDayjsLocale)
    case 'it':
      return import('dayjs/locale/it').then(setDayjsLocale)
    case 'pl':
      return import('dayjs/locale/pl').then(setDayjsLocale)
    case 'sv':
      return import('dayjs/locale/sv').then(setDayjsLocale)
    case 'ru':
      return import('dayjs/locale/ru').then(setDayjsLocale)
  }
})()
